import { useNavigate } from "react-router-dom";

import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";

import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import DrawerAppBar from "../components/DrawerAppBar";
import Title from "../components/Title";

import SETTINGS from "../settings.json";
import { useJwtStorage, useLocalStorage } from "../hooks/useLocalStorage";
import { getUserPriority } from "../services/UserService";

const About = () => {
  const [_jwt] = useJwtStorage();
  const navigate = useNavigate();

  const handlePrivacy = () => {
    window.open(
      "https://www.alltimely.com/privacy.html",
      "_blank",
      "noreferrer"
    );
  };

  const handleTerms = () => {
    window.open("https://www.alltimely.com/terms.html", "_blank", "noreferrer");
  };

  const handleServiceStatus = () => {
    navigate("/adm/service-status");
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="About" showBack={true} />

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">
            Versions
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <h3>App Version Number</h3>
                51.0.0
              </Grid>
              <Grid item xs={6}>
                <h3>Build Number</h3>
                {SETTINGS.version}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">Links</AccordionSummary>
          <AccordionDetails>
            <ButtonGroup
              fullWidth
              orientation="vertical"
              aria-label="vertical contained button group"
              variant="contained"
              sx={{ mt: 2 }}
            >
              <>
                <Button key="privacy" onClick={handlePrivacy} sx={{ mb: 1 }}>
                  PRIVACY
                </Button>
                <Button key="terms" onClick={handleTerms} sx={{ mb: 1 }}>
                  TERMS
                </Button>
                {getUserPriority(_jwt) === 800 && (
                  <Button key="status" onClick={handleServiceStatus}>
                    Service Status
                  </Button>
                )}
              </>
            </ButtonGroup>
          </AccordionDetails>
        </Accordion>

        <div style={{ marginTop: "1em" }}>
          &copy; 2026 The Local Machine, LLC
        </div>
      </Container>
    </>
  );
};

export default About;
